import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
};

const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setStoreToken(state, action) {
      state.token = action.payload;
    },
  },
});

export const { setStoreToken } = tokenSlice.actions;

export default tokenSlice.reducer;